import { axios } from '../axios';

class SegmentService {
  list(body) {
    return axios.post('/segment/list', body);
  }

  post(body) {
    return axios.post('/segment/', body);
  }

  put(body) {
    return axios.put(`/segment/${body.id}`, body);
  }

  delete(id) {
    return axios.delete(`/segment/${id}`);
  }
}

export default new SegmentService();
